import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearFormDiagnosticoNaturalezaLesionZonaAfectada, getFormDiagnosticoNaturalezaLesionZonaAfectada } from "../../../actions/forms";

const useDiagnosticoNaturalezaLesionZonaAfectada = (artId, disableZonaAfectada, disableNaturalezaLesion) => {
  const dispatch = useDispatch();
  const diagnosticoNaturalezaLesionZonaAfectada = useSelector((state) => state.forms.diagnosticoNaturalezaLesionZonaAfectada.data);
  const naturalezasLesion = useSelector((state) => state.forms.naturalezasLesion.data);
  const zonasAfectadas = useSelector((state) => state.forms.zonasAfectadas.data);
  const [filteredZonasAfectadas, setFilteredZonasAfectadas] = useState(zonasAfectadas);
  const [filteredNaturalezasLesion, setFilteredNaturalezasLesion] = useState(naturalezasLesion);
  const initialZonaAfectadaRef = useRef(null);
  const initialNaturalezaLesionRef = useRef(null);

  useEffect(() => {
    return () => {
      dispatch(clearFormDiagnosticoNaturalezaLesionZonaAfectada());
    };
  }, []);
  const updateFilteredZonasAfectadas = (diagnosticoOms, naturalezaLesion, newDiagnosticoNaturalezaLesionZonaAfectada = diagnosticoNaturalezaLesionZonaAfectada, isChangeDiagnostico = false) => {
    let filteredZonasAfectadasRet = zonasAfectadas
    if (diagnosticoOms !== null && !disableZonaAfectada && newDiagnosticoNaturalezaLesionZonaAfectada.length > 0) {
      const newFilteredZonasAfectadas = zonasAfectadas.filter(
        (zona) => newDiagnosticoNaturalezaLesionZonaAfectada.some((d) => d.zonaId === zona.id && (d.naturalezaId === naturalezaLesion || !naturalezaLesion || isChangeDiagnostico)) || zona.id === initialZonaAfectadaRef.current
      )
      filteredZonasAfectadasRet = newFilteredZonasAfectadas;
    }
    setFilteredZonasAfectadas(filteredZonasAfectadasRet);
    return filteredZonasAfectadasRet;
  }

  const updateFilteredNaturalezasLesion = (diagnosticoOms, zonaAfectada, newDiagnosticoNaturalezaLesionZonaAfectada = diagnosticoNaturalezaLesionZonaAfectada, isChangeDiagnostico = false) => {
    let filteredNaturalezaLesionRet = naturalezasLesion;
    if (diagnosticoOms !== null && !disableNaturalezaLesion && newDiagnosticoNaturalezaLesionZonaAfectada.length > 0) {
      const newFilteredNaturalezasLesion = naturalezasLesion.filter(
        (naturaleza) => newDiagnosticoNaturalezaLesionZonaAfectada.some((d) => d.naturalezaId === naturaleza.id && (d.zonaId === zonaAfectada || !zonaAfectada || isChangeDiagnostico)) || (naturaleza.id === initialNaturalezaLesionRef.current)
      );
      filteredNaturalezaLesionRet = newFilteredNaturalezasLesion;
    }
    setFilteredNaturalezasLesion(filteredNaturalezaLesionRet);
    return filteredNaturalezaLesionRet;
  }

  const updateFilteredZonasAfectadasAndNaturalezasLesion = (diagnosticoOms, naturalezaLesion, zonaAfectada, newDiagnosticoNaturalezaLesionZonaAfectada = diagnosticoNaturalezaLesionZonaAfectada, callBack) => {
    let filteredZonasAfectadasRet = updateFilteredZonasAfectadas(diagnosticoOms, naturalezaLesion, newDiagnosticoNaturalezaLesionZonaAfectada, true);
    let filteredNaturalezaLesionRet = updateFilteredNaturalezasLesion(diagnosticoOms, zonaAfectada, newDiagnosticoNaturalezaLesionZonaAfectada, true);
    if (callBack) {
      callBack(filteredNaturalezaLesionRet, filteredZonasAfectadasRet);
    }
  };

  const getDiagnosticoNaturalezaLesionZonaAfectada = (diagnosticoOms, naturalezaLesion, zonaAfectada, callBack) => {
    if (diagnosticoOms) {
      dispatch((getFormDiagnosticoNaturalezaLesionZonaAfectada(artId, diagnosticoOms))).then((res) => {
        if (res?.value?.data) {
          updateFilteredZonasAfectadasAndNaturalezasLesion(diagnosticoOms, naturalezaLesion, zonaAfectada, res.value.data, callBack);
        }
      })
    } else {
      dispatch(clearFormDiagnosticoNaturalezaLesionZonaAfectada());
      setFilteredZonasAfectadas(zonasAfectadas);
      setFilteredNaturalezasLesion(naturalezasLesion);
    }
  }

  const setInitialNaturalezaLesionAndZonaAfectada = (naturalezaLesion, zonaAfectada) => {
    if (zonasAfectadas.some((z) => z.id === zonaAfectada)) {
      initialZonaAfectadaRef.current = zonaAfectada;
    }
    if (naturalezasLesion.some((n) => n.id === naturalezaLesion)) {
      initialNaturalezaLesionRef.current = naturalezaLesion;
    }
  }

  const clearDiagnosisInitialInclusions = () => {
    initialZonaAfectadaRef.current = null;
    initialNaturalezaLesionRef.current = null;
  }

  return [
    filteredZonasAfectadas,
    filteredNaturalezasLesion,
    updateFilteredZonasAfectadas,
    updateFilteredNaturalezasLesion,
    getDiagnosticoNaturalezaLesionZonaAfectada,
    setInitialNaturalezaLesionAndZonaAfectada,
    clearDiagnosisInitialInclusions,
  ]
}

export default useDiagnosticoNaturalezaLesionZonaAfectada;